// Generated by Melange

import AlbumPageModuleCss from "./albumPage.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__Album from "../shared/album.jsx";
import * as Shared__Container from "../shared/container.jsx";
import * as Shared__Duration from "../shared/duration.jsx";
import * as Shared__H1 from "../shared/h1.jsx";
import * as Shared__H2 from "../shared/h2.jsx";
import * as Shared__MediaHeader from "../shared/mediaHeader.jsx";
import * as Shared__MediaLinks from "../shared/mediaLinks.jsx";
import * as Shared__Prose from "../shared/prose.jsx";
import * as Shared__Skeleton from "../shared/skeleton.jsx";
import * as Shared__SongList from "../shared/songList.jsx";
import * as Shared__StarButton from "../shared/starButton.jsx";
import * as Stdlib__Array from "melange/array.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__List from "melange/list.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Shallow from "zustand/react/shallow";

const css = AlbumPageModuleCss;

function AlbumPage(Props) {
  let albumId = Props.albumId;
  let deferredAlbumInfo = Props.deferredAlbumInfo;
  const base = Store__Context.useAppStore(function (state) {
    return Caml_option.undefined_to_opt(state.albums.baseById.get(albumId));
  });
  const details = Store__Context.useAppStore(function (state) {
    return Caml_option.undefined_to_opt(state.albums.detailsById.get(albumId));
  });
  const songIds = Store__Context.useAppStore(function (state) {
    return Caml_option.undefined_to_opt(state.albums.songIdsById.get(albumId));
  });
  const selector = Shallow.useShallow(function (state) {
    return Stdlib__Option.map((function (songIds) {
      return Stdlib__Array.of_list(Stdlib__List.filter_map((function (id) {
        return Caml_option.undefined_to_opt(state.songs.byId.get(id));
      }), Stdlib__Array.to_list(songIds)));
    }), songIds);
  });
  const songs = Store__Context.useAppStore(selector);
  const discs = React.useMemo((function () {
    if (details === undefined) {
      return;
    }
    if (songs === undefined) {
      return;
    }
    const result = [];
    songs.forEach(function (song) {
      const discNumber = Stdlib__Option.value(song.discNumber, 1);
      const discTitle = Stdlib__Option.bind(details.discTitles, (function (discTitles) {
        return Caml_option.undefined_to_opt(discTitles.find(function (x) {
          return x.disc === discNumber;
        }));
      }));
      const arg_songIds = [];
      const arg_title = Stdlib__Option.bind(discTitle, (function (x) {
        if (x.title.length === 0) {
          return;
        } else {
          return x.title;
        }
      }));
      const arg = {
        number: discNumber,
        songIds: arg_songIds,
        title: arg_title
      };
      result[discNumber - 1 | 0] = (function (param) {
        return Stdlib__Option.value(param, arg);
      })(Belt__Belt_Array.get(result, discNumber - 1 | 0));
      const disc = result[discNumber - 1 | 0];
      disc.songIds.push(song.id);
    });
    return result;
  }), [
    details,
    songs
  ]);
  const renderAlbumInfo = function (fallback, children) {
    return JsxRuntime.jsx(Store__Context.Consumer.make, {
      children: (function (albumInfo) {
        if (albumInfo !== undefined) {
          return Curry._1(children, albumInfo);
        } else if (deferredAlbumInfo !== undefined) {
          return JsxRuntime.jsx(ReactRouter.Await, {
            fallback: fallback,
            promise: Caml_option.valFromOption(deferredAlbumInfo),
            children: Curry.__1(children)
          });
        } else {
          return fallback;
        }
      }),
      selector: (function (state) {
        return Caml_option.undefined_to_opt(state.albums.infoById.get(albumId));
      })
    });
  };
  let tmp;
  if (base !== undefined) {
    let tmp$1 = {
      albumId: base.id,
      className: css.starButton
    };
    if (base.starred !== undefined) {
      tmp$1.starred = Caml_option.valFromOption(base.starred);
    }
    tmp = JsxRuntime.jsxs(React.Fragment, {
      children: [
        JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(base.name), undefined, undefined, undefined, {
          albumId: base.id
        }, undefined, "/album/$albumId", undefined)),
        JsxRuntime.jsx(Shared__StarButton.make, tmp$1)
      ]
    });
  } else {
    tmp = JsxRuntime.jsx(Shared__Skeleton.make, {
      style: {
        width: "16rem"
      }
    });
  }
  let tmp$2;
  if (base !== undefined) {
    const arg = null;
    const duration = base.duration;
    tmp$2 = JsxRuntime.jsxs(React.Fragment, {
      children: [
        (function (param) {
          return Stdlib__Option.value(param, arg);
        })(Stdlib__Option.map((function (year) {
          return JsxRuntime.jsxs(React.Fragment, {
            children: [
              year,
              " – "
            ]
          });
        }), base.year)),
        JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(base.artist), undefined, undefined, undefined, {
          artistId: base.artistId
        }, undefined, "/artist/$artistId", undefined)),
        " – ",
        duration !== undefined ? Shared__Duration.format(duration) : null
      ]
    });
  } else {
    tmp$2 = JsxRuntime.jsx(Shared__Skeleton.make, {
      style: {
        width: "5rem"
      }
    });
  }
  let tmp$3;
  let exit = 0;
  if (base !== undefined && details !== undefined && discs !== undefined) {
    if (discs.length > 1) {
      tmp$3 = JsxRuntime.jsx("div", {
        children: discs.map(function (disc) {
          const Key = Stdlib__Int.to_string(disc.number);
          const title = disc.title;
          let tmp = {
            getSongElementId: Shared__Album.getSongElementId,
            isAlbumView: true,
            primaryArtist: base.artist,
            songIds: disc.songIds,
            songIdsToPlay: songIds
          };
          if (details.isCompilation !== undefined) {
            tmp.isCompilation = Caml_option.valFromOption(details.isCompilation);
          }
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs(Shared__H2.make, {
                children: [
                  "Disc ",
                  disc.number,
                  title !== undefined ? JsxRuntime.jsxs(React.Fragment, {
                      children: [
                        " – ",
                        title
                      ]
                    }) : null
                ],
                className: css.discTitle
              }),
              JsxRuntime.jsx(Shared__SongList.make, tmp)
            ]
          }, Key);
        }),
        className: css.discs
      });
    } else {
      let tmp$4 = {
        getSongElementId: Shared__Album.getSongElementId,
        isAlbumView: true,
        primaryArtist: base.artist
      };
      if (details.isCompilation !== undefined) {
        tmp$4.isCompilation = Caml_option.valFromOption(details.isCompilation);
      }
      if (songIds !== undefined) {
        tmp$4.songIds = Caml_option.valFromOption(songIds);
      }
      tmp$3 = JsxRuntime.jsx(Shared__SongList.make, tmp$4);
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$3 = JsxRuntime.jsx(Shared__SongList.make, {});
  }
  return JsxRuntime.jsxs(Shared__Container.make, {
    children: [
      JsxRuntime.jsx(Shared__MediaHeader.make, {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: "Album",
                  className: css.tag
                }),
                JsxRuntime.jsx(Shared__H1.make, {
                  children: tmp
                }),
                JsxRuntime.jsx("div", {
                  children: tmp$2,
                  className: css.subtitle
                })
              ]
            }),
            renderAlbumInfo(JsxRuntime.jsx(Shared__Prose.make, {}), (function (albumInfo) {
              const arg = null;
              let param = Stdlib__Option.map((function (html) {
                return JsxRuntime.jsx(Shared__Prose.make, {
                  html: html
                });
              }), albumInfo.notes);
              return Stdlib__Option.value(param, arg);
            }))
          ],
          className: css.info
        }),
        coverArt: Stdlib__Option.map((function (x) {
          return x.coverArt;
        }), base),
        links: renderAlbumInfo(JsxRuntime.jsx(Shared__MediaLinks.make, {
          skeleton: true
        }), (function (albumInfo) {
          let tmp = {};
          if (albumInfo.lastFmUrl !== undefined) {
            tmp.lastFmUrl = Caml_option.valFromOption(albumInfo.lastFmUrl);
          }
          const tmp$1 = Stdlib__Option.map((function (id) {
            return "https://musicbrainz.org/release/" + id;
          }), albumInfo.musicBrainzId);
          if (tmp$1 !== undefined) {
            tmp.musicBrainzUrl = Caml_option.valFromOption(tmp$1);
          }
          return JsxRuntime.jsx(Shared__MediaLinks.make, tmp);
        }))
      }),
      tmp$3
    ],
    className: css.root
  });
}

const make = AlbumPage;

export {
  make,
}
/* css Not a pure module */
